import { apiCall, NEW_BE_API } from '../../utils/APIFunctions';

export function reviewDocument(documentId) {
  return apiCall(`${NEW_BE_API}/api/n1/documents/${documentId}/review`, "PUT");
}

export function fetchDocumentReview(documentId) {
  return apiCall(`${NEW_BE_API}/api/n1/documents/${documentId}/review`, "GET");
}

export function updateTimeline(documentId, reviewId) {
  return apiCall(`${NEW_BE_API}/api/n1/documents/${documentId}/review/${reviewId}/timeline`, "PUT");
}